import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Col, Row, Input, Table } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const WorkOrdersTable = ({loading = false, workOrders = []}) => {
    const history = useHistory();

    const [inputValue, setInputValue] = useState('');

    const dataColumns = [
        {title: 'Apertura', dataIndex: 'openTimestamp', defaultSorter: 'ascend', sorter: (a, b) => new Date(a.openTimestamp) - new Date(b.openTimestamp)},
        {dataIndex: 'name'},
        {title: 'Habitación', dataIndex: 'room', defaultSorter: 'ascend', sorter: (a,b) => a.room - b.room},
        {title: 'Estado', dataIndex: 'status', defaultSorter: 'ascend', sorter: (a,b) => a.status > b.status}
    ];

    const cleanInputValue = inputValue.trim().toLowerCase();
    const filteredWorkOrders = cleanInputValue
        ? workOrders.filter(i => i.room?.toLowerCase().includes(cleanInputValue))
        : workOrders;

    return (
        <Row style={{display: 'flex', flexFlow: 'column', width: '100%'}}>
            <Row style={{width: '100%', height: 40, marginBottom: 40}}>
                <Col span={12} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <Input
                        size="middle"
                        prefix={<SearchOutlined />}
                        placeholder={'Buscar'}
                        allowClear={true}
                        value={inputValue}
                        onChange={(ev) => setInputValue(ev.target.value)}
                    />
                </Col>
            </Row>

            <Row style={{width: '100%', height: '100%', flexGrow: 1, marginBottom: 20}}>
                <Col offset={1} span={22}>
                    <Table
                        style={{cursor: 'pointer'}}
                        size="middle"
                        columns={dataColumns}
                        rowKey={'id'}
                        dataSource={filteredWorkOrders}
                        scroll={{y: 440}}
                        locale={{
                            emptyText: 'No se encontraron datos',
                            cancelSort: 'Haz clic para cancelar ordenar',
                            triggerAsc: 'Haz clic para ordenar - ascendente',
                            triggerDesc: 'Haz clic para ordenar - descendente'
                        }}
                        onRow={(record) => {
                            return {
                                onClick: () => {
                                    history.push('/app/maintenance/work-orders/' + record.id);
                                }
                            };
                        }}
                        pagination={{
                            pageSize: 8,
                            showTotal: (total) => `Total: ${total}`
                        }}
                        loading={{
                            spinning: loading,
                            delay: 500,
                            size: 'large'
                        }}
                    />
                </Col>
            </Row>
        </Row>
    );
};

export default WorkOrdersTable;